<template>
    <div class="d-flex">

        <div class="chooseBtn btn tertiary d-flex flex-column" :class="{'border-color-1': value}" @click="setButton(true)">
            <span class="mb-2 bold">Invite an Agent</span>
            <span class="fs-smallest">Less time on phone calls, Send a login so your agents can enter into the community</span>
        </div>

        <div class="chooseBtn btn tertiary d-flex flex-column" :class="{'border-color-1': !value}" @click="setButton(false)">
            <span class="mb-2 bold">Create Private Agent</span>
            <span class="fs-smallest">Create a offline internal profile. More time with phone calls.</span>
        </div>

    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import extendedVSelect from '@/extends/vue-select'

export default {
    data: function () {
        return {
            // value: false
        }
    },
    computed: {

    },
    methods: {
        setButton: function(val) {
            // this.value = val
            this.$emit('input', val)
        }
    },
    components: {
        vSelect: extendedVSelect
    },
    props: {
        value: Boolean,
        default: false
    }
}
</script>

<style lang="scss" scoped>
    .chooseBtn{
        line-height: normal;
        height: 80px;
        width: 190px;
        margin-right: 0.5rem;

        &.border-color-1{
            border-width: 2px !important;
        }
    }
</style>



// WEBPACK FOOTER //
// AgentNewSelector.vue?731c41f6